import { DISTANCES } from '../constants/distances'

export function getMergeDistance(zoom) {
  return DISTANCES[zoom] || 0;
}
